import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA  } from '@angular/core';
import { FormsModule }   from '@angular/forms';

import { HttpModule }    from '@angular/http';
import { AppRoutingModule }     from './app-routing.module';

import { AppComponent } from './app.component';
import {EditProductComponent} from "./edit-product.component";
import {ManageProductsComponent} from "./manage-products.component";
import {ImageUploadModule} from "angular2-image-upload";
import {ManageTypesComponent} from "./manage-types.component";
import {ModalComponent} from "./components/modal-component";
import {MenuComponent} from "./components/menu-component";
import {ManageMenusComponent} from "./manage-menus.component";
import {ClientProductsComponent} from "./client-products.component";
import {AgmCoreModule} from "@agm/core";
import {MDBBootstrapModule} from 'angular-bootstrap-md';

import { ModalModule } from 'ngx-modialog';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';

import {ToastyModule} from "ng2-toasty";
import {ManageOrdersComponent} from "./manage-orders.component";
import {PhonePipe} from "./components/phone-pipe.component";
import {AdminLoginComponent} from "./admin-login.component";
import {AuthGuard} from "./guards/auth.guard";

@NgModule({
  declarations: [
    AppComponent,
    ClientProductsComponent,
    AdminLoginComponent,
    EditProductComponent,
    ManageProductsComponent,
    ManageTypesComponent,
    ManageMenusComponent,
    ManageOrdersComponent,
    ModalComponent,
    MenuComponent,
    PhonePipe
  ],
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    AppRoutingModule,
    ImageUploadModule.forRoot(),
    MDBBootstrapModule.forRoot(),
    ToastyModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBYSUEyeSuHtpxYdn7GU56YGT04IrTK3BE'
    }),
    ModalModule.forRoot(),
    BootstrapModalModule
  ],
  exports: [
      PhonePipe
  ],
providers: [AuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/app.module.ts